import getEdsGif from '@mos/eds-gif/dist';
import { useEffect, useState } from 'react';
import { DEFAULT_FETCH_OPTIONS, serviceID, xCallerId } from '../models/auth';
import { PASSPORT_STATUS } from '../constants/document';

declare global {
  interface Window {
    yaCounter32628510: any;
  }
}

const getCookie = (name) => {
  /* eslint-disable */
  const matches = document.cookie.match(
    new RegExp(
      '(?:^|; )' +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
        '=([^;]*)'
    )
  );
  /* eslint-enable */
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const sendStats = (eventObject) => {
  const params = {
    eventType: 'services_mos',
    eventSrc: 'mos.ru',
    eventDst: 'stats',
    eventTime: Date.now(),
    mosId: getCookie('mos_id'),
    eventObject,
  };

  getEdsGif(params);

  if (window.yaCounter32628510) {
    window.yaCounter32628510.params(eventObject);
  }
};

export const START_CLICK = {
  Services: {
    'mnogodetnaya-semia': {
      Посадочная: { 'Кнопка Подать заявление': { null: 'click' } },
    },
  },
};

export const stepComplete = ({
  stepNumber,
  stepTitle,
  childrenCount = null,
}) => ({
  Services: {
    'mnogodetnaya-semia': {
      'Страница заявления': {
        'Заполнение шага': {
          [stepTitle]: { next: { [stepNumber]: childrenCount } },
        },
      },
    },
  },
});

export const ADD_CHILD = {
  Services: {
    'mnogodetnaya-semia': {
      'Страница заявления': { 'Кнопка Добавить ребёнка': { null: 'click' } },
    },
  },
};

export const sendForm = (childrenCount, childrenBirthStatus) => ({
  Services: {
    'mnogodetnaya-semia': {
      'Страница заявления': {
        'Отправка заявления': {
          [childrenCount]: { [childrenBirthStatus]: 'send' },
        },
      },
    },
  },
});
type SuggestType = 'address_suggests' | 'street_suggests';

type LandingPageError =
  | 'snils_not_verified'
  | 'account_younger_14'
  | 'account_corporate'
  | 'service_unavailable';

export const landingPageError = (error: LandingPageError) => ({
  Services: {
    'mnogodetnaya-semia': {
      'Страница ошибки': {
        'Ошибки посадочной': {
          [error]: 'error',
        },
      },
    },
  },
});

type SubsequentRequestError = 'eirc' | 'omk';

export const addressSubsequentRequestError = (
  error: SubsequentRequestError
) => ({
  Services: {
    'mnogodetnaya-semia': {
      'Страница заявления': {
        'Ошибки адресного блока': {
          failed_to_check: {
            [error]: 'form_error',
          },
        },
      },
    },
  },
});

type AddressInputMode = 'manual_input' | 'address_suggests';

export const addressValidationError = (error: AddressInputMode) => ({
  Services: {
    'mnogodetnaya-semia': {
      'Страница заявления': {
        'Ошибки адресного блока': {
          invalid_input: {
            [error]: 'form_error',
          },
        },
      },
    },
  },
});

export type OMKErrorStat = { type: AddressInputMode; text: string };

export const addressOMKError = ({ type, text }: OMKErrorStat) => ({
  Services: {
    'mnogodetnaya-semia': {
      'Страница заявления': {
        'Ошибки адресного блока': {
          omk_code_not_found: {
            [type]: { address_input: text },
          },
        },
      },
    },
  },
});

export const addressFailedToSearchError = (type: SuggestType) => ({
  Services: {
    'mnogodetnaya-semia': {
      'Страница заявления': {
        'Ошибки адресного блока': {
          failed_to_search_address: {
            [type]: 'error',
          },
        },
      },
    },
  },
});

export const addressSearchError = ({
  text,
  type,
}: {
  text: string;
  type: SuggestType;
}) => ({
  Services: {
    'mnogodetnaya-semia': {
      'Страница заявления': {
        'Ошибки адресного блока': {
          address_not_found: { [type]: { address_input: text } },
        },
      },
    },
  },
});

export const sendFormSuccess = (serviceNumber, childrenCount) => ({
  Services: {
    'mnogodetnaya-semia': {
      'Страница результата': {
        'Заявление успешно отправлено': {
          service_number: serviceNumber,
          children_number: childrenCount,
          [childrenCount]: 'send',
        },
      },
    },
  },
});

type OrganizationError =
  | 'failed_to_search_school'
  | 'failed_to_search_hospital';

export const organizationError = (error: OrganizationError) => ({
  Services: {
    'mnogodetnaya-semia': {
      'Страница заявления': {
        'Ошибки организации': {
          [error]: 'error',
        },
      },
    },
  },
});

export type FormErrorStat =
  | 'Добавлено менее трех детей'
  | 'Заявление не удалось отправить'
  | 'Паспорт истек'
  | 'Паспорт истекает';

export const formError = (type: FormErrorStat) => ({
  Services: {
    'mnogodetnaya-semia': {
      'Страница заявления': { 'Ошибки формы': { [type]: 'form_error' } },
    },
  },
});

type FormPageStatus = 'Новое' | 'Загружено из черновика';
export const sendFormPageStatus = (status: FormPageStatus) => ({
  Services: {
    'mnogodetnaya-semia': {
      'Страница заявления': status,
    },
  },
});

export const resetFormClick = () => ({
  Services: {
    'mnogodetnaya-semia': {
      'Страница заявления': {
        'Загружено из черновика': 'Нажатие Начать оформление заново',
      },
    },
  },
});

export const AddressMissingDataInformerStats = () => ({
  Services: {
    'mnogodetnaya-semia': {
      'Страница заявления': {
        'Информер Укажите адрес вручную': { null: 'click' },
      },
    },
  },
});

export const useStepCompleteSendStats = (
  isStatsSending,
  complete,
  { stepNumber, stepTitle, childrenCount }
) => {
  useEffect(() => {
    if (!complete || !isStatsSending) return;
    sendStats(stepComplete({ stepNumber, stepTitle, childrenCount }));
  }, [complete]);
};

export const useChildrenSendStats = (
  isStatsSending,
  childrenCount,
  { stepNumber }
) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isStatsSending) {
      setCount(childrenCount);
      return;
    }
    if (childrenCount === count) return;
    if (childrenCount > count) {
      sendStats(
        stepComplete({
          stepNumber,
          stepTitle: 'Добавление ребёнка',
          childrenCount,
        })
      );
      setCount(childrenCount);
    }
    if (childrenCount < count) {
      sendStats(
        stepComplete({
          stepNumber,
          stepTitle: 'Удаление ребёнка',
          childrenCount,
        })
      );
      setCount(childrenCount);
    }
  }, [childrenCount]);
};

export const PassportStatusStat = {
  [PASSPORT_STATUS.EXPIRED]: 'Паспорт истек',
  [PASSPORT_STATUS.EXPIRING]: 'Паспорт истекает',
};
type PassportStatus = typeof PassportStatusStat[keyof typeof PassportStatusStat];
export const passportStatus = (status: PassportStatus) => ({
  Services: {
    'mnogodetnaya-semia': {
      'Страница заявления': { 'Ошибки формы': { [status]: 'form_error' } },
    },
  },
});

export type RequestBody = {
  rate: number;
  comment?: string;
  eno?: string;
  category?: 1 | 2 | number;
};

export const sendFeedback = (params: RequestBody) => {
  const { rate, comment, eno } = params;

  const body: RequestBody = {
    rate: Number(rate),
    // 1: Удобство подачи услуги
    category: 1,
  };
  if (comment && comment.length > 0) {
    body.comment = comment;
  }
  if (eno) {
    body.eno = eno;
  }

  const url = `/api/cma-rating/v1/rating/${serviceID}`;

  fetch(url, {
    ...DEFAULT_FETCH_OPTIONS,
    method: 'POST',
    headers: {
      ...DEFAULT_FETCH_OPTIONS.headers,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }).then((response) => response.json());
};
